<template>
  <div class="info-item">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "UserCompany",

}
</script>
<style lang="less" scoped>
  .item-image{
    width: 66px;
  }
  .company-item{
    height: 86vh;
    overflow: auto;
  }
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.decription{
  width: 600px;
}
.info-item{
  min-height: 91vh;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: 10px;
  padding: 10px 30px;

  .item-table{
    font-size: 12px;
    img{
      width: 66px;
      height: 30px;
    }
  }
  .dialog{
    height: 525px;
  }
}
</style>